<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-01 14:11:23
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-02-19 15:46:28
 * @Description: file content
 很多宝 模板底部菜单
 -->

<template>
  <div class="tabbar4">
    <div v-for="item in navData" class="tabbar_item" @click="clickItem(item)">
      <img class="tabbar_icon" :src="item.ico" />
      <span class="tabbar_text">{{item.name}}</span>
    </div>
    <ShowImg2 v-if="showImg2.isShow" :my="showImg2" v-on:close="showImg2.isShow=false"></ShowImg2>
    <ShowImg3 v-if="showImg3.isShow" :my="showImg3" v-on:close="closeShowImg3"></ShowImg3>
  </div>
</template>
<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import wx from "weixin-js-sdk";
import { mapState, mapMutations } from "vuex";
const ShowImg2 = () => import("@/components/showimg2.vue");
const ShowImg3 = () => import("@/components/showimg3.vue");
import { MessageBox } from "mint-ui";
export default {
  components: {
    ShowImg2,
    ShowImg3
  },
  props: {},
  data() {
    return {
      //底部导航
      navData: [
        {
          name: "关注作者",
          click: "clickFollowAuthor",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar4/guanzhuzuozhe.png"
        },
        {
          name: "更多精彩",
          click: "clickWonder",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar4/gengduojingcai.png"
        },
        {
          name: "互动提问",
          click: "clickQuestion",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar4/hudongtiwen.png"
        }
      ],
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      },
      showImg3: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      },
      isShowShare: false //是否显示分享
    };
  },
  watch: {},
  computed: {
    ...mapState(["sourceGzhInfo", "pageInfo", "userInfo", "isInMiniProgram"])
  },
  methods: {
    clickItem(item) {
      this[item.click]();
    },
    clickFollowAuthor() {
      /**
很多宝：
关注：弹出框提示信息（您很有品味，我们将为您订阅Xxx的内容。）框上两个按钮：确认（设置偏好，跳转到公众号文章列表页），取消
未关注：弹出框，框里显示很多宝的二维码和一句文案（扫码关注很多宝，获取xxx（作者名称）的关注入口，同时认识更多甄选高品质作者）。二维码识别以后，关注很多宝公众号，后端主动对当前用户做订阅作者操作，并推出当前作者的文章列表（页面内含有作者二维码）页面链接消息（文本消息还是模版消息？）。
       */
      if (
        this.userInfo &&
        this.userInfo.user &&
        this.userInfo.user.state == 1
      ) {
        // 已关注
        MessageBox.confirm(
          `您很有品味，我们将为您订阅“${this.sourceGzhInfo.tabvalue}”的内容`
        ).then(() => {
          comreq.subscribe(this.$openid, this.sourceGzhInfo.id).then(() => {
            util.openUrl(
              `http://henduobao.quanc.com.cn/act/hdbplatform/codeInfo?id=${this.sourceGzhInfo.id}`
            );
          });
        });
      } else {
        // 未关注
        comreq
          .getHDBWxAppQRCode(this.sourceGzhInfo.id, this.$openid)
          .then(res => {
            this.showImg3 = {
              url: res.Data,
              width: "70%",
              intro: `扫码获取${this.sourceGzhInfo.tabvalue}官微入口，结识更多臻选大咖`,
              isShow: true
            };
          });
      }
    },
    clickWonder() {
      this.showImg2 = {
        isShow: true,
        url:
          "https://assets.rurushishi.com/yq-rs-make/components/tabbar4/hdbqrcode.png",
        width: "80%",
        intro: ""
      };
    },
    clickQuestion() {
      util.openUrl(util.getGzhChatUrl(this));
    },
    closeShowImg3() {
      this.showImg3.isShow = false;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="css" scoped>
/* 底部导航 */
.tabbar4 {
  width: 100%;
  height: 50px;
  background: #fff;
  /* background: #f5af19; */
  /* background: linear-gradient(to right, #f5af19, #f12711); */
  /* background: linear-gradient(to right, #4CB8E9, #007DA6); */
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-top: 1px solid #c6c6c6;
}

.tabbar_item {
  flex: 1;
  text-align: center;
  position: relative;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tabbar_icon {
  width: 20px;
  height: 20px;
  padding-right: 5px;
}

.tabbar_text {
  display: inline-block;
  color: #000000;
  font-size: 12px;
}
</style>

